var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.8572 18.5M19.8572 18.5L17 12L14.1428 18.5M19.8572 18.5H14.1428M14.1428 18.5L13 21M8 3L8.5 4.5M3 5.5H14M5 8C5 8 5.89476 11.1304 8.1316 12.8696C10.3684 14.6087 14 16 14 16M12 5.5C12 5.5 11.1052 9.60871 8.8684 11.8913C6.6316 14.1739 3 16 3 16",
    stroke: "#C02FB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.fa571b19c92b63d8f0d5b73221afa1b7.svg";
export { ForwardRef as ReactComponent };